<template>
    <li class="event-item">
        <label class="event-item__label">
            <input class="event-item__check" type="radio" name="event" :id="event.name" :value="event.name" @click="getCategory(event.id, event.name)" @change="$emit('change', $event.target.value)">

            <img class="event-item__img" :src="event.img" alt="">
            {{ event.name }}
        </label>
    </li>
</template>

<script>
    export default {
        props: {
            event: {
                type: Object,
                required: true
            }
        },
		methods: {
			getCategory: function(catID, catName) {
				const data = {
					text: this.getSearchText,
					cat: catID,
					dish: this.getFilterDish,
					event: this.getFilterEvent,
					people: this.getFilterPeople,
					price: this.getFilterPrice
				};

				const payload = {
					catID: catID,
					catName: catName
				};

				this.$store.dispatch('setSearchCat', payload);
				this.$store.dispatch('setSearchProducts', data);
			}
		},
		computed: {
			searchText() {
				return this.$store.getters.getSearchText;
			},
			searchCat() {
				return this.$store.getters.getSearchCat;
			},
		}
    };
</script>

<style lang="scss" scoped>
    .event-item {
        padding: 0 27px;
        transition: color $dur $ease;
        @include mq($md, min) {
            &:not(:last-child) {
                margin-bottom: 33px;
            }
        }
        @include hover {
            color: $burning-orange;
        }

        @include mq($md) {
            width: 50%;
            margin-bottom: 20px;
        }
        @include mq($sm) {
            width: 100%;
        }
    }

    .event-item__check {
        display: none;
    }

    .event-item__label {
        display: flex;
        align-items: center;
        font-size: 15px;
        letter-spacing: 0.75px;
    }
    .event-item__img {
        width: 28px;
        margin-right: 33px;
    }
</style>
